import React from 'react';
import Link from 'next/link';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import qs from 'qs';

const ProductCategoryLink = ({
  productCategory,
  organizationProductCategory,
  shopConfig,
  className,
}) => {
  let category = productCategory;
  const usesOrganizationProductCategories =
    shopConfig?.usesOrganizationProductCategories;
  const categoryType = usesOrganizationProductCategories
    ? 'organizationProductCategory'
    : 'productCategory';
  if (usesOrganizationProductCategories) {
    category = organizationProductCategory;
  }
  if (!category) return <br />;

  const splitCategory = category.split('|');
  const displayCategory = splitCategory[splitCategory.length - 1];
  const categoryQueryString = encodeURIComponent(
    qs.stringify({
      [categoryType]: { iLike: `${category}%` },
    }),
  );
  return (
    <Link href={`/articles?filter=${categoryQueryString}`}>
      <span className={`category ${className}`}>{displayCategory}</span>
    </Link>
  );
};
ProductCategoryLink.propTypes = {
  productCategory: PropTypes.string,
  organizationProductCategory: PropTypes.string,
  shopConfig: PropTypes.object,
  className: PropTypes.string,
};
ProductCategoryLink.defaultProps = {
  className: '',
  productCategory: '',
  organizationProductCategory: '',
  shopConfig: {},
};

const mapStateToProps = ({ shopConfig }) => ({
  shopConfig,
});
export default connect(mapStateToProps)(ProductCategoryLink);
